import { css, Interpolation, Theme } from '@emotion/react'
import { memo } from 'react'
import { URL_MFC_SHARE } from '../../constants/urls'
import Share from '../Icons/Share'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import { PAPER_HEIGHTS } from '../theme'
import LinkButton from './LinkButton'

const buttonStyles = css({
    alignItems: 'center',
    backgroundColor: palette.background,
    height: 48,
    display: 'flex',
    justifyContent: 'center',
    margin: getThemeSpacing(0.5),
    zIndex: PAPER_HEIGHTS.floatingActionBar,
    '&:hover img': {
        filter: 'saturate(0) brightness(2.25)',
    },
})

interface IButtonShare {
    slug?: string
    styleOverrides?: Interpolation<Theme>
}

const ButtonShare = (props: IButtonShare) => {
    const { slug, styleOverrides } = props

    return (
        <LinkButton
            overrides={[buttonStyles, styleOverrides]}
            data-testid="Button__Share"
            href={`${URL_MFC_SHARE}/${slug}`}
        >
            <Share />
        </LinkButton>
    )
}

export default memo(ButtonShare)
